import { useToast } from '@repo/design-system/index'
import { useQueryClient } from '@tanstack/react-query'
import { useUpdateTutorNotification } from '../../../../modules/apis/student/tutors'
import { tutorProfileQueryApi } from '../../../../modules/apis/student/tutors/queries'
import { n_tutor } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'

interface TutorNotification {
  tutorId: number
}

const useTutorNotification = () => {
  const queryClient = useQueryClient()
  const { t, locale } = useTranslation()
  const { toastInfo } = useToast()

  const { mutate } = useUpdateTutorNotification()

  const showSuccessToast = (activate: boolean) => {
    const toastMessage = activate ? n_tutor.toast_schedule_alarm_on : n_tutor.toast_schedule_alarm_off

    toastInfo(t(toastMessage))
  }

  const updateNotificationStatus = (tutorId, activate: boolean, onSuccess?: () => void) => {
    mutate(
      { tutorId, activate },
      {
        onSuccess: () => {
          showSuccessToast(activate)
          queryClient.invalidateQueries(
            tutorProfileQueryApi.getQueryKey({
              searchParams: { tutor_id: tutorId, locale },
            })
          )
          onSuccess?.()
        },
      }
    )
  }

  return { updateNotificationStatus }
}

export default useTutorNotification
